import { create } from "zustand";

export const usePartnerLanding = create((set, get) => ({
  isMobile: false,
  isVisibleBookButton: false,

  updateFields: (fields) => set(fields),
}));
